import { render, staticRenderFns } from "./VirtualManage.vue?vue&type=template&id=54ba6f60&scoped=true&"
import script from "./VirtualManage.vue?vue&type=script&lang=js&"
export * from "./VirtualManage.vue?vue&type=script&lang=js&"
import style0 from "./VirtualManage.vue?vue&type=style&index=0&id=54ba6f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba6f60",
  null
  
)

export default component.exports